import { FundSeriesAndInvestor } from 'model/series';
import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { GetAllSeriesPortfolioTypes } from './types';

export const getAllSeriesPortfolioRequest = () => action(GetAllSeriesPortfolioTypes.GET_ALL_SERIES_PORTFOLIO_REQUEST);
export const getAllSeriesPortfolioSuccess = (response: FundSeriesAndInvestor[]) => action(GetAllSeriesPortfolioTypes.GET_ALL_SERIES_PORTFOLIO_SUCCESS, response);
export const getAllSeriesPortfolioError = (error: GiroWebappError) => action(GetAllSeriesPortfolioTypes.GET_ALL_SERIES_PORTFOLIO_ERROR, error);
export const getAllSeriesPortfolioResetState = () => action(GetAllSeriesPortfolioTypes.GET_ALL_SERIES_PORTFOLIO_RESET_STATE);
